import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768; // px, adjust as needed

function useDevice(): boolean {
  // 2. Bootstrap the state based on the current width (on client)
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined'
      ? window.innerWidth <= MOBILE_BREAKPOINT
      : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    // 1. Run once on mount so we don't wait for the next resize
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

export default useDevice;
